export const AvatarShimmer = () => {
  return <span className="bg-gray-200 animate-pulse w-full h-full"></span>;
};
